<template>
  <li :class="[prefixMenuClass + '__item-group']">
    <span :class="[prefixMenuClass + '__item-group-title']">{{ title }}</span>
    <ul>
      <slot></slot>
    </ul>
  </li>
</template>
<script>
import { PREFIX_MENU_CLASS } from './constants'

export default {
  name: 'TMenuGroup',
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      prefixMenuClass: PREFIX_MENU_CLASS
    }
  }
}
</script>



// WEBPACK FOOTER //
// menu-group.vue?94f3afc6